<template lang="pug">

	b-card.animated.fadeIn.mb-3

		h6.mb-0(slot="header") Доступные действия

		div(v-for="opt in options")

			div(v-if="opt==='S'")
				b-button.mb-3(variant='primary' data-target="#tabs" @click="switchTab(1,$event)") Составить личную программу

			div(v-else-if="opt==='F'")
				div.mb-3 Оплата получена в полном объеме. Ждем Вас на нашем мероприятии!

			i-option(v-else-if="opt==='I'")


			t-option(v-else-if="opt==='T'")


			p-option(v-else-if="opt==='P'")


			e-option(v-else-if="opt==='E'")

			div(v-else-if="opt==='M'")
				div.mb-3
					b-alert(variant="success" show)
						| Вы можете скачать материалы
						|
						b-link(:href="myParticipant.data.event.materials_url") ЗДЕСЬ

			div(v-else-if="opt==='Q'")
				div.mb-3
					b-alert(variant="success" show)
						| Для регистрации на мероприятие можно воспользоваться
						b-button.mx-2(v-b-modal.modal-1 size="sm" variant="success") QR-кодом
						| (покажите его на стойке регистрации)
					b-modal#modal-1(title="BootstrapVue" hide-footer hide-header centered )
						div.text-center(v-if="qrcodeUrl")
							img(:src="qrcodeUrl" style="max-width:100%;")

			div(v-else-if="opt==='C'")
				b-alert(show variant="success") Благодарим Вас за участие в мероприятии и ждем в следующем году!
				| Вы можете загрузить сертификат участника нажав на кнопку ниже

				b-button.schedule-header__btn.my-3(variant="primary" @click="dlCertificate" :disabled="isDlCert")
					b-spinner.mr-2(small label="Small Spinner" v-if="isDlCert")
					i.fa.fa-file-pdf-o.fa-md.mr-2(v-else)
					span Загрузить сертификат в PDF

			div(v-else-if="opt==='L'")
				| Спасибо за успешное прохождение процесса регистрации
</template>

<script>
	import smoothScrollToEl from '@/MIXINS/smoothScrollToEl';
	import forceFileDownload from '@/MIXINS/forceFileDownload'

	import pOption from './options/p-option'
	import iOption from './options/i-option'
	import tOption from './options/t-option'
	import eOption from './options/e-option'
	import {mapState} from "vuex";


	export default {
		name: 'Options',
		props: [ 'options' ],
		components: {
			pOption,
			iOption,
			tOption,
			eOption,
		},
		mixins: [
			smoothScrollToEl,
			forceFileDownload,
		],
		data: () => ({
			transition: 'slide-right',
			isDlCert: false,
			qrcodeUrl: null,
			msg: {
				netErr: 'Произошла ошибка! Проверьте интернет соединение или попробуйте повторить попытку позднее!'
			}
		}),
		computed: {
			...mapState(['myParticipant']),
			participantID(){ return this.myParticipant.data.id },
		},
		methods: {
			dlCertificate(){
				this.isDlCert = true;
				this.$store.dispatch('downloadCertificate',{id:this.participantID})
					.then(resp=>{
						if ( !resp || !resp.ok ) throw resp.body;

						this.forceFileDownload(resp.data, 'certificate');
						this.isDlCert = false;
					})
					.catch(err=>{
						this.isDlCert = false;
						this.makeToast(null, err.statusText || this.msg.netErr, 'danger');
					})
			},
			makeToast(append=false, msg='default text', variant='info', noHide=false) {
				this.$bvToast.toast([msg], {
					title: 'Центр уведомлений',
					toaster: 'b-toaster-bottom-right',
					autoHideDelay: 2000,
					appendToast: append,
					variant: variant,
					noAutoHide: noHide
				})
			},
			async switchTab(num){
				await this.$store.dispatch('changeTab', num);
				await this.smoothScrollToEl('#tabs', 65);
				await this.showTabMarker(num);
			},
			showTabMarker(num){
				const scheduleTab = document.querySelectorAll('.info-tabs .nav-link');
					scheduleTab[num].classList.add('anim');
				setTimeout(()=>{ scheduleTab[num].classList.remove('anim') },2000)
			},

		},
		beforeMount(){
			this.$store.dispatch('getQrCode',{id:this.myParticipant.data.id}).then((response)=>{
				this.qrcodeUrl = window.URL.createObjectURL(new Blob([response.data],{type: "application/octet-stream"}))
			});
		}
	}
</script>

<style>
	.nav-link.active.anim {
		animation: NAME-YOUR-ANIMATION .5s linear;
		animation-iteration-count: 4;
	}
	@keyframes NAME-YOUR-ANIMATION {
		0%   {
			background-color: inherit;
		}
		50%   {
			background-color: #cdedd8;
		}
		100% {
			background-color: inherit;
		}
	}
</style>
